/* Confezione regalo — Prestige Home
 *
 * Sorgente di verità:
 *   · riga prodotto con property "Confezione regalo" = "Sì" → una confezione per quel prodotto
 *   · attributo carrello "Confezione regalo ordine" = "Sì"  → una confezione unica per l'ordine
 *
 * Esclusione: i prodotti con tag "Dropshipping" partono dal fornitore e non sono
 * incartabili. Il tema non mostra la casella sulle loro schede né il toggle sulle
 * loro righe di carrello, e reconcile() rimuove qualunque confezione finisse
 * comunque agganciata a uno di essi.
 *
 * Dalla scheda prodotto la confezione viene aggiunta PRIMA del prodotto,
 * trattenendo per un istante l'invio del form: così il drawer si apre già completo.
 */
(function () {
  'use strict';

  var CFG = window.giftWrapConfig || {};
  var WRAP_ID = Number(CFG.variantId || 0);
  if (!WRAP_ID) return;

  var PROP = 'Confezione regalo';
  var ATTR = 'Confezione regalo ordine';
  var YES = 'Sì';
  var PRE_ADD_TIMEOUT = 1500;

  var locked = false;
  var wrapWanted = false;

  /* ------------------------------------------------------------------ utils */

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      cartJs: (r.cart || '/cart') + '.js',
      add: r.cartAdd || '/cart/add.js',
      change: r.cartChange || '/cart/change.js',
      update: r.cartUpdate || '/cart/update.js'
    };
  }

  async function getCart() {
    var res = await fetch(routes().cartJs, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    return res.json();
  }

  async function post(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(data.description || data.message || url + ' ' + res.status);
    return data;
  }

  function isManagedWrap(item) {
    return item.variant_id === WRAP_ID && !!(item.properties || {})._gw;
  }

  /* Varianti non incartabili presenti nel carrello, scritte da cart-items.liquid.
     In mancanza del dato non blocco nulla: meglio una confezione di troppo,
     che reconcile toglierà al giro dopo, di una funzione che smette di andare. */
  function cartFlags() {
    var el = document.querySelector('.js-gw-cart-data');
    var blocked = {};
    if (el && el.dataset.blocked) {
      el.dataset.blocked.split(',').forEach(function (v) {
        v = v.trim();
        if (v) blocked[v] = true;
      });
    }
    return { blocked: blocked, hasWrappable: !el || el.dataset.wrappable !== 'false' };
  }

  async function refreshCart() {
    var el = document.querySelector('.cc-main-cart cart-items') || document.querySelector('cart-items');
    if (el && typeof el.refresh === 'function') {
      try {
        await el.refresh();
        return;
      } catch (e) {
        /* sotto il fallback */
      }
    }
    if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
  }

  /* ---------------------------------------------------------- riconciliazione */

  async function reconcile() {
    var cart = await getCart();
    var flags = cartFlags();
    var orderWanted = (cart.attributes || {})[ATTR] === YES;

    var marked = {};
    var wraps = [];
    var ops = [];

    cart.items.forEach(function (item) {
      if (isManagedWrap(item)) {
        wraps.push(item);
        return;
      }
      if (item.variant_id === WRAP_ID) return;
      if ((item.properties || {})[PROP] !== YES) return;

      var k = String(item.variant_id);

      // Prodotto diventato non incartabile: tolgo la marcatura.
      if (flags.blocked[k]) {
        var cleaned = Object.assign({}, item.properties);
        cleaned[PROP] = '';
        ops.push({ op: 'props', key: item.key, properties: cleaned });
        return;
      }

      if (marked[k]) marked[k].qty += item.quantity;
      else marked[k] = { qty: item.quantity, title: item.product_title };
    });

    var seen = {};

    wraps.forEach(function (w) {
      var target = w.properties._gw;

      if (target === 'order') {
        if (orderWanted && flags.hasWrappable && !seen.order) seen.order = true;
        else ops.push({ op: 'remove', key: w.key });
        return;
      }

      if (orderWanted || flags.blocked[target] || !marked[target] || seen[target]) {
        ops.push({ op: 'remove', key: w.key });
        return;
      }

      seen[target] = true;
      if (w.quantity > marked[target].qty) {
        ops.push({ op: 'qty', key: w.key, quantity: marked[target].qty });
      }
    });

    if (orderWanted && flags.hasWrappable) {
      if (!seen.order) {
        ops.push({ op: 'add', properties: { _gw: 'order', Confezione: "Unica per tutto l'ordine" } });
      }
    } else if (!orderWanted) {
      Object.keys(marked).forEach(function (k) {
        if (seen[k]) return;
        ops.push({ op: 'add', properties: { _gw: k, 'Confezione per': marked[k].title } });
      });
    }

    // Ordine tutto in dropshipping: niente da incartare, spengo anche l'attributo.
    var clearOrderAttr = orderWanted && !flags.hasWrappable;

    if (!ops.length && !clearOrderAttr) return false;

    for (var i = 0; i < ops.length; i += 1) {
      var o = ops[i];
      if (o.op === 'remove') {
        await post(routes().change, { id: o.key, quantity: 0 });
      } else if (o.op === 'qty') {
        await post(routes().change, { id: o.key, quantity: o.quantity });
      } else if (o.op === 'props') {
        await post(routes().change, { id: o.key, properties: o.properties });
      } else {
        await post(routes().add, { items: [{ id: WRAP_ID, quantity: 1, properties: o.properties }] });
      }
    }

    if (clearOrderAttr) await setOrderAttribute(false);

    return true;
  }

  async function sync(forceRefresh) {
    if (locked) return;
    locked = true;
    try {
      var changed = await reconcile();
      if (changed || forceRefresh) await refreshCart();
    } catch (e) {
      console.error('[confezione-regalo]', e);
    } finally {
      locked = false;
    }
  }

  /* -------------------------------------------------------------- attributi */

  async function setOrderAttribute(on) {
    var cart = await getCart();
    var attrs = Object.assign({}, cart.attributes || {});
    attrs[ATTR] = on ? YES : '';
    await post(routes().update, { attributes: attrs });
  }

  async function clearItemMarks(cart) {
    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      if (item.variant_id === WRAP_ID) continue;
      var props = item.properties || {};
      if (props[PROP] !== YES) continue;
      var next = Object.assign({}, props);
      next[PROP] = '';
      await post(routes().change, { id: item.key, properties: next });
    }
  }

  /* ---------------------------------------------------------------- toggle */

  async function onItemToggle(input) {
    var key = input.dataset.lineKey;
    var wanted = input.checked;
    var box = input.closest('.gw');

    if (!key || locked) {
      input.checked = !wanted;
      return;
    }

    locked = true;
    if (box) box.classList.add('is-busy');

    try {
      var cart = await getCart();
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!line) throw new Error('riga non trovata: ' + key);

      var props = Object.assign({}, line.properties || {});
      props[PROP] = wanted ? YES : '';
      await post(routes().change, { id: key, properties: props });

      if (wanted && (cart.attributes || {})[ATTR] === YES) {
        await setOrderAttribute(false);
      }
    } catch (e) {
      console.error('[confezione-regalo]', e);
    } finally {
      locked = false;
      if (box) box.classList.remove('is-busy');
    }

    await sync(true);
  }

  async function onOrderToggle(input) {
    var wanted = input.checked;
    var box = input.closest('.gw');

    if (locked) {
      input.checked = !wanted;
      return;
    }

    locked = true;
    if (box) box.classList.add('is-busy');

    try {
      if (wanted) {
        var cart = await getCart();
        await clearItemMarks(cart);
      }
      await setOrderAttribute(wanted);
    } catch (e) {
      console.error('[confezione-regalo]', e);
    } finally {
      locked = false;
      if (box) box.classList.remove('is-busy');
    }

    await sync(true);
  }

  /* --------------------------------------------------------- scheda prodotto */

  function isMainProductForm(form) {
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return false;
    if (form.classList.contains('js-instalments-form')) return false;
    if (!form.querySelector('[name="add"]') || !form.querySelector('[name="id"]')) return false;
    if (form.closest('quick-add-drawer')) return false;
    if (form.closest('product-card') || form.closest('.product-card') || form.closest('.card--product')) return false;
    return true;
  }

  function applyProperty(form) {
    var hidden = form.querySelector('.js-gw-hidden');

    if (!wrapWanted) {
      if (hidden) hidden.disabled = true;
      return;
    }

    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + PROP + ']';
      hidden.className = 'js-gw-hidden';
      form.appendChild(hidden);
    }

    hidden.value = YES;
    hidden.disabled = false;
  }

  function onProductToggle(input) {
    wrapWanted = input.checked;

    document.querySelectorAll('.js-gw-product').forEach(function (cb) {
      cb.checked = wrapWanted;
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (isMainProductForm(form)) applyProperty(form);
    });
  }

  function productTitle() {
    var el = document.querySelector('h1.product-title') || document.querySelector('.product-info h1');
    return el ? el.textContent.trim() : '';
  }

  function preAddWrap(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return Promise.resolve();
    if (Number(idInput.value) === WRAP_ID) return Promise.resolve();

    var props = { _gw: String(idInput.value) };
    var title = productTitle();
    if (title) props['Confezione per'] = title;

    return post(routes().add, { items: [{ id: WRAP_ID, quantity: 1, properties: props }] });
  }

  function resubmit(form) {
    var btn = form.querySelector('[name="add"]');
    form.dataset.gwPending = '1';

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn);
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  var mountCounter = 0;

  function mountProductForms() {
    document.querySelectorAll('.js-product-form-main').forEach(function (form) {
      if (form.dataset.gwMounted) return;
      if (!isMainProductForm(form)) return;

      var addBtn = form.querySelector('[name="add"]');
      var idInput = form.querySelector('[name="id"]');
      if (idInput && Number(idInput.value) === WRAP_ID) return;

      form.dataset.gwMounted = '1';

      var block;

      if (CFG.blocked) {
        // Prodotto in dropshipping: niente casella, solo la spiegazione.
        block = document.createElement('p');
        block.className = 'gw-note';
        block.textContent = CFG.blockedNote || '';
      } else {
        mountCounter += 1;
        var uid = 'gw-product-' + mountCounter;

        block = document.createElement('div');
        block.className = 'gw gw--product';
        block.innerHTML =
          '<input type="checkbox" class="checkbox js-gw-product" id="' + uid + '"' +
          (wrapWanted ? ' checked' : '') + '>' +
          '<label class="gw__label" for="' + uid + '">Aggiungi la confezione regalo' +
          (CFG.priceFormatted ? '<span class="gw__price">+ ' + CFG.priceFormatted + '</span>' : '') +
          '</label>';
      }

      var anchor = addBtn;
      while (anchor.parentElement && anchor.parentElement !== form) {
        anchor = anchor.parentElement;
      }
      if (anchor.parentElement !== form) anchor = addBtn;

      anchor.insertAdjacentElement('beforebegin', block);
      if (!CFG.blocked) applyProperty(form);
    });
  }

  /* ---------------------------------------------------------------- listener */

  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!t || !t.matches) return;

    if (t.matches('.js-gw-item')) {
      evt.stopPropagation();
      onItemToggle(t);
    } else if (t.matches('.js-gw-order')) {
      evt.stopPropagation();
      onOrderToggle(t);
    } else if (t.matches('.js-gw-product')) {
      evt.stopPropagation();
      onProductToggle(t);
    }
  }, true);

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!isMainProductForm(form)) return;

    applyProperty(form);

    if (!wrapWanted || CFG.blocked) return;

    if (form.dataset.gwPending === '1') {
      delete form.dataset.gwPending;
      return;
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var timeout = new Promise(function (resolve) { setTimeout(resolve, PRE_ADD_TIMEOUT); });

    Promise.race([preAddWrap(form).catch(function (e) {
      console.error('[confezione-regalo]', e);
    }), timeout]).then(function () {
      resubmit(form);
    });
  }, true);

  document.addEventListener('on:cart:add', function () {
    setTimeout(function () { sync(false); }, 900);
  });

  document.addEventListener('on:line-item:change', function () {
    setTimeout(function () { sync(true); }, 200);
  });

  function init() {
    mountProductForms();
    if (document.querySelector('cart-items[data-empty="false"]')) sync(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', mountProductForms);

  var mountTimer = null;
  new MutationObserver(function () {
    clearTimeout(mountTimer);
    mountTimer = setTimeout(mountProductForms, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();